import { source } from '../constants';

const initialState = {
  isFetching: false,
};

// function buildBody(action) {
//     return {
//     widget.resultsTemplate 找到uid符合傳將結果傳入其data
//     mediaType: action.mediaType,
//     mediaSource: action.mediaSource,
//     fetched: action.fetched,
//     lastUpdated: action.receivedAt
//   }
// }

export function widgetSource(state = initialState, action) {
  switch (action.type) {
    case source.REQUEST:
      return {
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt };
    case source.RECEIVE:
      return {
        ...state,
        mediaType: action.mediaType,
        mediaSource: action.mediaSource,
        typeReport: action.typeReport,
        fetched: action.fetched,
        isFetching: false,
        lastUpdated: action.receivedAt
      };
    case source.REQUEST_CH:
      return {
        ...state,
        lastUpdated: action.receivedAt };
    case source.RECEIVE_CH:
      return {
        ...state,
        channelReport: action.channelReport,
        lastUpdated: action.receivedAt
      };
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/widgetSource.reducer.js